import Component from '@glimmer/component';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import Settings from 'donor-elf-web/services/settings';
import dateUtils from 'donor-elf-web/lib/date-utils';
import { tracked } from '@glimmer/tracking';
import { getChangesetErrorsForProperty } from 'donor-elf-web/lib/changeset-utils';

interface ComponentArgs {
  changeset: any;
  property: string;
  disabled?: boolean;
  showValidationErrors?: boolean;
  onChange: (val: any) => void;
}

export default class FormUnderlineDateComponent extends Component<ComponentArgs> {
  @service declare settings: Settings;

  @tracked pikadayContainer?: any;

  get changesetVal() {
    let val = this.args.changeset.get(this.args.property);
    if (typeof val === 'string') {
      // correctly adjust for timezone
      val = dateUtils.deserializeDateOnly(val);
    }
    return val;
  }

  set changesetVal(_val: any) {
    // intentionally don't do anything when Pikaday tries to change the value
    // because handleSelction() below takes care of changes
  }

  handleSelect = (val: any) => {
    this.args.changeset.set(this.args.property, val);
    this.args.onChange?.(val);
  };

  handlePikadayContainerDidInsert = (el: any) => {
    this.pikadayContainer = el;
  }

  get showError() {
    return this.args.showValidationErrors && isPresent(this.errorMessage);
  }

  get errorMessage() {
    return getChangesetErrorsForProperty(this.args.changeset, this.args.property)?.join(', ');
  }
}
